import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './DropdownMenu.css';

const DropdownMenu = ({ trigger, children, isOpen, onClose, className = '' }) => {
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  // Calculate position when menu opens
  useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const menuWidth = 160; // approximate menu width
      const isRTL = document.documentElement.dir === 'rtl';
      
      let top = rect.bottom + 4;
      let left = isRTL ? rect.right - menuWidth : rect.left;
      
      // Check if menu would go off screen to the right
      if (left + menuWidth > window.innerWidth) {
        left = window.innerWidth - menuWidth - 10;
      }
      
      // Check if menu would go off screen to the left
      if (left < 10) {
        left = 10;
      }
      
      // Check if menu would go off screen at the bottom
      const menuHeight = 150; // approximate menu height
      if (top + menuHeight > window.innerHeight) {
        top = rect.top - menuHeight - 4;
      }
      
      setPosition({ top, left });
    }
  }, [isOpen]);

  // Close on click outside
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (
        menuRef.current && 
        !menuRef.current.contains(e.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(e.target)
      ) {
        onClose?.();
      }
    };

    const handleScroll = () => {
      onClose?.();
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('scroll', handleScroll, true);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('scroll', handleScroll, true);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const menu = isOpen ? ReactDOM.createPortal(
    <div 
      ref={menuRef}
      className={`dropdown-portal-menu ${className}`}
      style={{
        position: 'fixed',
        top: position.top,
        left: position.left,
        zIndex: 999999
      }}
    >
      {children}
    </div>,
    document.body
  ) : null;

  return (
    <>
      <div ref={triggerRef} className="dropdown-trigger-wrapper">
        {trigger}
      </div>
      {menu}
    </>
  );
};

export default DropdownMenu;
